import { render, staticRenderFns } from "./newHeaderFooter.vue?vue&type=template&id=648ecba7"
import script from "./newHeaderFooter.vue?vue&type=script&lang=js"
export * from "./newHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports